import { render, staticRenderFns } from "./ItemTable.vue?vue&type=template&id=65587707"
import script from "./ItemTable.js?vue&type=script&scoped=true&lang=js&external"
export * from "./ItemTable.js?vue&type=script&scoped=true&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports